import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { axiosInstance } from '../../helpers'
import { Lead, LeadTour } from '../../models/Outreach/types'

export interface CreateLeadWithTourPayload {
    name: string
    email?: string
    phone?: string
    starts_at: string
    ends_at?: string
    given_by_id?: number | null
    notes?: string
    preferred_unit_config?: number | null
    preferred_move_in_date?: string | null
}

export interface CreateLeadWithTourResponse {
    lead: Lead
    tour: LeadTour
}

export function useCreateLeadWithTour() {
    const queryClient = useQueryClient()

    const mutation = useMutation({
        mutationFn: async (payload: CreateLeadWithTourPayload) => {
            const {
                data,
            } = await axiosInstance.post<CreateLeadWithTourResponse>(
                '/beta/api/outreach/leads/create-with-tour/',
                payload,
            )
            return data
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ['apartment-tours'],
                exact: false,
            })
            queryClient.invalidateQueries({
                queryKey: ['leads'],
                exact: false,
            })
            toast.success('Tour scheduled successfully')
        },
        onError: (error: {
            response?: { data?: { error?: string; detail?: string } }
        }) => {
            toast.error(
                error?.response?.data?.error ??
                    error?.response?.data?.detail ??
                    'Failed to schedule tour',
            )
        },
    })

    return {
        createLeadWithTour: mutation.mutateAsync,
        isCreating: mutation.isLoading,
    }
}
